/**
 * distillr.ts - Distillr (Data Distillation System) preferences module
 * 
 * CHANGE HISTORY:
 * - 251102_0928 [pending] danielbeer: Renamed from filtr to distillr
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const distillrModule = {
  id: 'data-distillr',
  name: 'Data Distillation System',
  icon: '🔍',
  category: 'modules',
  order: 30,
  
  packageInfo: {
    name: '@opcentral/distillr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Universal data distillation system for extracting and filtering specific data paths and values',
    status: 'in-progress',
    implementationProgress: 60,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*'
    },
    keywords: ['filter', 'search', 'query', 'data'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableAdvancedFilters: {
      type: 'boolean',
      label: 'Enable Advanced Filters',
      description: 'Allow complex filter expressions',
      defaultValue: true
    },
    
    saveFilters: {
      type: 'boolean',
      label: 'Save Filter Presets',
      description: 'Allow saving filter configurations',
      defaultValue: true
    },
    
    caseSensitive: {
      type: 'boolean',
      label: 'Case Sensitive',
      description: 'Make text filters case sensitive',
      defaultValue: false
    }
  }
};

export default distillrModule;
